<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="size"
    :height="size"
    :style="{ minWidth: size }"
    viewBox="0 0 20 20"
    fill="none"
  >
    <mask
      id="mask0_11596_188664"
      style="mask-type: alpha"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="21"
      height="20"
    >
      <path
        d="M10.5003 13.3333V9.16666M10.5003 6.66666H10.5087M18.8337 10C18.8337 14.6024 15.1027 18.3333 10.5003 18.3333C5.89795 18.3333 2.16699 14.6024 2.16699 10C2.16699 5.39762 5.89795 1.66666 10.5003 1.66666C15.1027 1.66666 18.8337 5.39762 18.8337 10Z"
        stroke="black"
        stroke-width="1.75"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </mask>
    <g mask="url(#mask0_11596_188664)">
      <rect x="0.5" width="20" height="20" fill="#726CE7" />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'IconNotification',
  props: {
    size: {
      type: [Number, String],
      default: 20,
    },
  },
}
</script>
